// import api from "../utils/api";

export const DELETE_ITEM = 'delete_item';
export const REORDER_LIST_ITEM = 'reorder_list_item';
export const SET_ITEM = 'set_item';
export const SET_INTV = 'set_interactive';

export const ADD_ASSET = 'add_asset';
export const DELETE_ASSET = 'delete_asset';
export const DELETE_ALL_ASSETS = 'delete_all_assets';

export const SET_DIRTY = 'set_dirty';
export const SET_CLEAN = 'set_clean';

export const SET_ERROR = 'set_error';
export const DELETE_ERROR = 'delete_error';
export const DELETE_ALL_ERRORS = 'delete_all_errors';

export const SET_USER = 'set_user';

export const deleteItem = (path) => {
  return {
    type: DELETE_ITEM,
    payload: { path }
  }
}

export const reorderListItem = (path, start, end ) => {
  return {
    type: REORDER_LIST_ITEM,
    payload: { path, start, end }
  }
}

export const setItem = (path, value ) => {
  return {
    type: SET_ITEM,
    payload: { path, value }
  }
}

export const setInteractiveData = (intv) => {
  return {
    type: SET_INTV,
    payload: intv
  }
}


// ASSETS
export const addAsset = (asset) => {
  return {
    type: ADD_ASSET,
    payload: asset
  }
}

export const deleteAsset = (index) => {
  return {
    type: DELETE_ASSET,
    payload: index
  }
}

export const deleteAllAssets = (index) => {
  return {
    type: DELETE_ALL_ASSETS,
    payload: index
  }
}


// DIRTY
export const setDirty = () => {
  return {
    type: SET_DIRTY,
    payload: true
  }
}

export const setClean = (uuid) => {
  // api.unlockIntv(uuid)
  //   .then(res => console.log(res))
  //   .catch(err => console.log(err));
  return {
    type: SET_CLEAN,
    payload: false
  }
}


// ERRORS
export const setGlobalError = (id,path) => {
  return {
    type: SET_ERROR,
    payload: {id,path}
  }
}

export const deleteGlobalError = (id) => {
  return {
    type: DELETE_ERROR,
    payload: id
  }
}


export const clearGlobalErrors = () => {
  return {
    type: DELETE_ALL_ERRORS,
    payload: {}
  }
}

// USER
export const setUser = (user) => {
  return {
    type: SET_USER,
    payload: user
  }
}
